import { render } from "./UploadStudentDialog.vue?vue&type=template&id=ec7203e0&scoped=true"
import script from "./UploadStudentDialog.vue?vue&type=script&lang=js"
export * from "./UploadStudentDialog.vue?vue&type=script&lang=js"

import "./UploadStudentDialog.vue?vue&type=style&index=0&id=ec7203e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7203e0"]])

export default __exports__